<div class="CTP-gdpr a-link block">
  <div class="privacy-title-text">
    {{ 'data-protection' | sharedTranslate }}
  </div>

  @if (loading()) {
    <div class="w-full p-5">
      <ngx-skeleton-loader
        appearance="line"
        animation="progress"
        [count]="20"
      ></ngx-skeleton-loader>
    </div>
  } @else {
    <div
      class="font-efSans text-base text-justify text-mat-ef-revolution-primary-500"
      [innerHTML]="getPrimaryLegalText() | safeHtml"
    ></div>
    <div class="w-full flex justify-center">
      <div class="w-full md:max-w-[680px]">
        <ng-container *ngTemplateOutlet="dealerSelect"></ng-container>

        @if (!showConsents()) {
          <p
            class="font-efSans text-base text-justify text-mat-ef-revolution-primary-500 my-2"
          >
            *
            <T
              str="Consents are currently unavailable, please try again later."
              key="customerPortal.customer-portal.gdpr.consents-unavailable"
              tags="customer-portal, 3.21"
            ></T>
          </p>
        } @else {
          <div class="w-full md:max-w-[680px]">
            @if (consentsResponse()?.group) {
              <div
                class="text-lg my-4 font-semibold text-mat-ef-revolution-primary-500"
              >
                <T
                  str="Dealership"
                  key="customerPortal.customer-portal.gdpr.dealership"
                  tags="customer-portal, 3.21"
                ></T>
              </div>
              <ng-container
                *ngTemplateOutlet="
                  consent;
                  context: { consent: consentsResponse()?.group, type: 'group' }
                "
              ></ng-container>
            }

            @if (hasUnsignedBrandsConsent() || hasUnsignedDealershipConsent()) {
              <div
                class="flex items-center py-4 px-5 mt-6 mb-8 rounded-[6px] gap-4 bg-mat-ef-revolution-secondary-200 bg-opacity-30"
              >
                <mat-icon
                  svgIcon="error"
                  class="cursor-pointer text-mat-ef-red-secondary-500"
                ></mat-icon>
                <div class="font-efSans text-mat-ef-revolution-primary-500">
                  <T
                    str="Missing consent:"
                    key="customerPortal.customer-portal.gdpr.missing-consent-label"
                    tags="customer-portal, 3.28"
                  ></T>
                  @if (hasUnsignedDealershipConsent()) {
                  <span>
                    &nbsp;<T
                      str="dealership"
                      key="customerPortal.customer-portal.gdpr.dealership-consent-label"
                      tags="customer-portal, 3.28"
                    ></T
                  ></span>
                  } @if (hasUnsignedDealershipConsent() && hasUnsignedBrandsConsent())
                  {
                  <span>,</span>
                  } @if (hasUnsignedBrandsConsent()) {
                  <span
                    >&nbsp;<T
                      str="brands"
                      key="customerPortal.customer-portal.gdpr.brands-consent-label"
                      tags="customer-portal, 3.28"
                    ></T
                  ></span>
                  }
                </div>
              </div>
            } @if (consentsResponse()?.dealers?.length > 0) {
              <div
                class="text-lg my-4 font-semibold text-mat-ef-revolution-primary-500"
              >
                @if (hasOnlyMarketingServicesGivenViaNewGdprOnDe()) {
                  <T
                    str="Marketing Services"
                    key="customerPortal.customer-portal.gdpr.marketing-services"
                    tags="customer-portal, 3.42"
                  ></T>
                } @else {
                  <T
                    str="Dealership"
                    key="customerPortal.customer-portal.gdpr.dealership"
                    tags="customer-portal, 3.21"
                  ></T>
                }
              </div>
              @for (d of sortedDealers(); track d.id) {
                <ng-container
                  *ngTemplateOutlet="consent; context: { consent: d, type: 'dealer' }"
                ></ng-container>
              }
            }
            @if (hasAnyBrandsConsent()) {
              <div>
                <div
                  class="text-lg my-4 font-semibold text-mat-ef-revolution-primary-500"
                >
                  <T
                    str="Brands"
                    key="customerPortal.customer-portal.gdpr.brands"
                    tags="customer-portal, 3.21"
                  ></T>
                </div>
                @for (b of sortedBrands(); track b.id) {
                  <ng-container
                    *ngTemplateOutlet="consent; context: { consent: b, type: 'brand' }"
                  ></ng-container>
                }
              </div>
            }
          </div>

          <div class="flex flex-row-reverse max-w-[1000px] mt-2.5 gap-4">
            <button
              mat-button
              mat-flat-button
              color="secondary"
              id="saveButton"
              class="revolution"
              (click)="updateConsents()"
              [disabled]="disabled() || updates().length === 0 || !dealerChannelsValid() || !brandChannelsValid()"
            >
              @if (disabled()) { <mat-spinner [diameter]="16"></mat-spinner> }
              <span> {{ 'save' | sharedTranslate }}</span>
            </button>

            @if (!hasOnlyMarketingServicesGivenViaNewGdprOnDe()) {
              <button
                color="basic"
                class="revolution icon-button"
                mat-button
                mat-flat-button
                (click)="downloadPrintFile(true)"
                [disabled]="disabled() || !consentsPartnerId()"
              >
                <mat-icon svgIcon="visibility_on" class="cursor-pointer"></mat-icon>
              </button>
              <button
                color="basic"
                class="revolution icon-button"
                mat-button
                mat-flat-button
                (click)="downloadPrintFile()"
                [disabled]="disabled() || !consentsPartnerId()"
              >
                <mat-icon class="cursor-pointer" svgIcon="download"></mat-icon>
              </button>
            }
          </div>
        }


      </div>
    </div>
  }
</div>

<ng-template
  #checkbox
  let-consent="consent"
  let-type="type"
  let-channel="channel"
  let-parentConsent="parentConsent"
>
  <div class="relative">
    <mat-checkbox
      class="h-6 flex items-center"
      [disabled]="
        checkboxIsDisabled(consent, channel.name) ||
        parentConsent.consentManagementUrl
      "
      color="primary"
      [checked]="getConsentValue(consent, channel.name)"
      (change)="
        updateConsentValue(
          type,
          parentConsent.id,
          consent.legalEntityId,
          channel.name,
          $event
        )
      "
    >
      <div class="text-sm">
        {{
          {
            str: channel.name,
            prefix: 'customerPortal.customer-portal.communication.'
          } | transifexTranslate
        }}
      </div>
    </mat-checkbox>
    @if (checkboxIsDisabled(consent, channel.name) &&
      !parentConsent.consentManagementUrl) {
      <div
        class="absolute left-0 top-0 w-full h-full"
        (click)="errorMessage(channel.name)"
      ></div>
    }
  </div>
</ng-template>

<ng-template #logo let-consent="consent">
  <img
    class="w-auto h-auto max-w-full max-h-full object-contain rounded m-auto"
    src="{{ consent?.logo ? consent.logo : 'assets/ef-logo.svg' }}"
    alt=""
    onerror="this.onerror=null; this.src='assets/ef-logo.svg'"
  />
</ng-template>

<ng-template #consent let-consent="consent" let-type="type">
  <div
    class="w-full rounded-md bg-mat-ef-revolution-grey-200 text-mat-ef-revolution-primary-500 p-4 md:p-6 flex flex-col mb-6 md:mb-12"
  >
    @if (type === 'brand') {
      <div class="flex mb-2">
        <div class="w-8">
          <ng-container
            *ngTemplateOutlet="logo; context: { consent: consent }"
          ></ng-container>
        </div>
        <div
          class="ml-6 flex-1 font-semibold text-base flex gap-2 justify-between"
        >
          <div>
            {{ consent.name }}
          </div>
          @if (consent.consentManagementUrlProviderName) {
            <button
              mat-button
              mat-flat-button
              color="basic"
              id="consentManagement"
              class="revolution min-h-[32px] leading-none small-button text-sm"
              (click)="openConsentManagementPage(consent)"
              [disabled]="!consent.consentManagementUrl || consent.consentManagementUrlSystemUnavailable || disabled()"
              [class.opacity-40]="!consent.consentManagementUrl || consent.consentManagementUrlSystemUnavailable"
            >
              @if (disabled()) { <mat-spinner [diameter]="16"></mat-spinner> }
              <T
                str="Collect and manage"
                key="customerPortal.customer-portal.gdpr.collect-and-manage.button"
                tags="customer-portal, 3.32"
              ></T>
            </button>
          }
        </div>
      </div>

      @if (consent.consentManagementUrlSystemUnavailable) {
        <div class="ml-14 flex items-start gap-2 px-3 py-2.5 mb-3 rounded-md border border-orange-300 bg-orange-50 text-sm font-normal">
          <mat-icon class="text-mat-ef-accent-orange-500 w-5 shrink-0 text-[20px]" svgIcon="info"></mat-icon>
          <span>{{
            {
              str: 'Consent management system {providerName} is currently unavailable',
              key: 'customerPortal.customer-portal.gdpr.consent-management.system-unavailable',
              params: { providerName: consent.consentManagementUrlProviderName }
            } | transifexTranslate
          }}</span>
        </div>
      } @else if (consent.consentManagementUrlMissingFields?.length) {
        <div class="ml-14 flex items-start gap-2 px-3 py-2.5 mb-3 rounded-md border border-orange-300 bg-orange-50 text-sm font-normal">
          <mat-icon class="text-mat-ef-accent-orange-500 w-5 shrink-0 text-[20px]" svgIcon="info"></mat-icon>
          <span>
            {{
              {
                str: 'To access {providerName} consent management system, please fill in the following required fields:',
                key: 'customerPortal.customer-portal.gdpr.consent-management.missing-fields-intro',
                params: { providerName: consent.consentManagementUrlProviderName }
              } | transifexTranslate
            }}
            <span class="font-semibold">
              @for (field of consent.consentManagementUrlMissingFields; track field; let isLast = $last) {
                {{ (missingFieldTranslations[field] ?? field) | sharedTranslate }}@if (!isLast) {, }
              }
            </span>
          </span>
        </div>
      }
    }

    <div class="flex">
      <div class="w-8">
        @if (type !== 'brand') {
          <ng-container
            *ngTemplateOutlet="logo; context: { consent: consent }"
          ></ng-container>
        }
      </div>

      <div
        [ngClass]="{ 'ml-6': type !== 'brand', '-ml-1': type === 'brand' }"
        class="flex-1 md:ml-6 flex flex-col gap-8"
      >
        @for (consentEl of consent.consents; track consentEl.legalEntityId) {
          <div class="flex-1 flex flex-col">
            <div class="flex-1 flex justify-between gap-2">
              <div class="flex-1">
                <div class="font-semibold text-base leading-none">
                  {{ consentEl.name }}
                </div>
                @if (type !== 'brand') {
                  <div class="font-semibold text-sm leading-none mt-1.5">
                    {{ consent.partnerName }} {{ consent.partnerSubname }}
                  </div>
                }

                <div class="text-sm opacity-70 leading-none mt-1.5">
                  {{ consentEl.address?.street
                  }}{{
                    consentEl.address?.zip ? ', ' + consentEl.address?.zip : ''
                  }}
                  {{ consentEl.address?.city }}
                </div>
              </div>
              @if (consentEl?.signed) {
                <div class="w-fit flex gap-1 text-sm -mt-[2px]">
                  <mat-icon class="text-green-500 w-5" svgIcon="create"></mat-icon>
                  <div class="opacity-70 pt-[1px]">
                    <T
                      str="Signed"
                      key="customerPortal.customer-portal.gdpr.signed"
                      tags="customer-portal, 3.21"
                    ></T>
                  </div>
                </div>
              } @else {
                <div class="w-fit flex gap-1 text-sm -mt-[2px]">
                  <mat-icon
                    class="text-mat-ef-accent-orange-500 w-5"
                    svgIcon="info"
                  ></mat-icon>
                  <div class="opacity-70 pt-[1px]">
                    <T
                      str="Not collected"
                      key="customerPortal.customer-portal.gdpr.not-collected"
                      tags="customer-portal, 3.28"
                    ></T>
                  </div>
                </div>
              }
            </div>

            <div class="flex">
              <div class="flex-1 flex flex-col">
                <div class="flex gap-1 mt-4">
                  <div class="w-fit flex items-center">
                    <mat-checkbox
                      class="h-6 w-6 md:float-right"
                      color="primary"
                      [checked]="getConsentValue(consentEl, 'checked')"
                      [disabled]="consent.consentManagementUrl"
                      (change)="
                        updateConsentValue(
                          type,
                          consent.id,
                          consentEl.legalEntityId,
                          'checked',
                          $event
                        )
                      "
                    ></mat-checkbox>
                  </div>
                  <div
                    class="text-sm leading-5 flex-1 max-w-[calc(100vw-90px)] md:max-w-[550px] break-words"
                    [innerHTML]="consentEl.legalText | safeHtml"
                  ></div>
                </div>
                @if (getConsentValue(consentEl, 'checked')) {
                  <div
                    class="mt-4 md:mt-6 flex flex-wrap gap-4 md:gap-6 ml-7 md:ml-0"
                  >
                    @for (channel of consentEl?.channels; track channel.name) {
                      <div class="flex gap-1 w-[45%] md:w-auto">
                        <ng-container
                          *ngTemplateOutlet="
                            checkbox;
                            context: {
                              consent: consentEl,
                              type: type,
                              channel: channel,
                              parentConsent: consent
                            }
                          "
                        ></ng-container>
                      </div>
                    }
                  </div>
                  @if (channelsNotValid(consentEl)) {
                    <div class="ml-7 md:ml-0 mt-2 text-xs font-semibold text-mat-ef-revolution-red-500">
                      <T
                        str="Please check at least one channel"
                        key="customerPortal.customer-portal.gdpr.check-channel"
                        tags="customer-portal, 3.42"
                      ></T>
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template #dealerSelect>
  @if (hasConsentDealers()) {
    <div class="mt-8 w-full md:w-[680px] text-mat-ef-revolution-primary-500">
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>
          {{ getTranslation('select-dealer') }}
        </mat-label>
        <input
          type="text"
          required
          matInput
          [matAutocomplete]="auto"
          [formControl]="consentDealerControl"
          name="consentDealerControl"
          [placeholder]="getTranslation('select-dealer')"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="formatDealerName"
        >
          @for (dealer of filteredConsentDealers(); track dealer.id) {
            <mat-option class="text-mat-ef-revolution-primary-500" [value]="dealer">
              {{ formatDealerName(dealer) }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
  }
</ng-template>
